import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class NSuppService {
  private apiUrl = '/nsupps';
  private apiSpringUrl = '/spring/nsupps';

  constructor(
    private http: HttpService) { }

  get(ownerId: number): Promise<any> {
    console.log(`NSuppService.get`);
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/${ownerId}`;
    return this.http.get(url);
  }

  confirm(ownerId: number, itemIdList: Set<number>, updprogramCd: string): Promise<any> {
    console.log(`NSuppService.confirm`);
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/confirm`;
    const jsonInput =  {
        ownerId: ownerId,
        updprogramCd: updprogramCd,
        itemIdList: Array.from(itemIdList.values())
    };
    
    return this.http.post(url, jsonInput);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/nsupp/nsupp.service.ts